"use client";
import React, { useEffect, useState } from "react";
import { EmailIcon, PasswordIcon, UserIcon } from "@/assets/icons";
// import Link from "next/link";
import { useRouter } from "next/navigation";

import InputGroup from "../FormElements/InputGroup";
// import { Checkbox } from "../FormElements/checkbox";
import toast from "react-hot-toast";
import localStorageService from "@/utils/localStorageService";
import { USER_LOGIN_DATA } from "@/utils/constants";
import { isMobileDevice } from "@/utils";
import { handleAuthResponse } from "@/lib/auth-handler";

export default function Register() {
  const [data, setData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirmation: "",
    isMobile: false,
  });

  const [loading, setLoading] = useState(false);

  const router = useRouter();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const { name, email, password, password_confirmation, isMobile } = data;

    if (!name) {
      toast.error(`Please enter your name`);
      return;
    }

    if (!email) {
      toast.error(`Please enter your email`);
      return;
    }

    if (!password) {
      toast.error(`Please enter your password`);
      return;
    }

    if (!password_confirmation) {
      toast.error(`Please confirm your password`);
      return;
    }

    if (password !== password_confirmation) {
      toast.error(`Passwords does not match`);
      return;
    }

    // Show loader on btn
    setLoading(true);

    try {
      // Call the server-side login API route
      const response = await fetch("/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          password,
          password_confirmation,
          isMobile,
        }),
        cache: "no-cache",
      });

      const result = await response.json();

      if (response?.ok) {
        // localStorageService?.setItem(USER_LOGIN_DATA, result);
        await handleAuthResponse(result);
        toast.success("Signup successful!");
        router.push("/dashboard/"); // Redirect to dashboard after signup
      } else {
        toast.error(result?.message || "Registration failed");
      }
    } catch (error) {
      toast.error(`Error during signup: ${error}`);
      console.error("Error during signup:", error);
    }
    // Hide loader on btn
    setLoading(false);
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      isMobile: isMobileDevice(),
    }));
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <InputGroup
        type="text"
        label="Name"
        className="mb-4 [&_input]:py-[15px]"
        placeholder="Enter your name"
        name="name"
        handleChange={handleChange}
        value={data.name}
        icon={<UserIcon />}
        required
      />
      <InputGroup
        type="email"
        label="Email"
        className="mb-4 [&_input]:py-[15px]"
        placeholder="Enter your email"
        name="email"
        handleChange={handleChange}
        value={data.email}
        icon={<EmailIcon />}
        required
      />

      <InputGroup
        type="password"
        label="Password"
        className="mb-5 [&_input]:py-[15px]"
        placeholder="Enter your password"
        name="password"
        handleChange={handleChange}
        value={data.password}
        icon={<PasswordIcon />}
        required
      />
      <InputGroup
        type="password"
        label="Confirm Password"
        className="mb-5 [&_input]:py-[15px]"
        placeholder="Confirm Password"
        name="password_confirmation"
        handleChange={handleChange}
        value={data.password_confirmation}
        icon={<PasswordIcon />}
        required
      />

      <div className="mb-4.5">
        <button
          type="submit"
          className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg bg-primary p-4 font-medium text-white transition hover:bg-opacity-90"
        >
          Sign Up
          {loading && (
            <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-white border-t-transparent dark:border-primary dark:border-t-transparent" />
          )}
        </button>
      </div>
    </form>
  );
}
